import { elevator } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchDataJson } from "../FetchApi";


class ElevatorService extends CrudService {
  constructor() {
    super(elevator);
  }

  async getElevatorWithDetails(id) {
    return fetchDataJson(`${elevator}/GetWithDetails/${id}`, {
      method: "GET",
    });
  }
}

export default new ElevatorService();
